// extracted by mini-css-extract-plugin
module.exports = {"word":"b2a4adca42f0d00446e122836cfdb85f"};